import { Component, createRef, RefObject } from "react";
import "./media.less";

interface AudioProps {
  url: string
}

interface State {
  isPlaying: boolean
  progress: number
  isDataLoaded: boolean
}

export default class Audio extends Component<AudioProps, State> {
  private readonly audioElemRef: RefObject<HTMLAudioElement>;

  constructor(props: AudioProps) {
    super(props)
    this.state = {
      isPlaying: false,
      progress: 0,
      isDataLoaded: false,
    }
    this.audioElemRef = createRef<HTMLAudioElement>();

    this.handleTogglePlay = this.handleTogglePlay.bind(this);
    this.handleLoadedData = this.handleLoadedData.bind(this);
    this.handlePlayEvent = this.handlePlayEvent.bind(this);
    this.handlePauseEvent = this.handlePauseEvent.bind(this);
    this.handleEndedEvent = this.handleEndedEvent.bind(this);
    this.handleTimeUpdateEvent = this.handleTimeUpdateEvent.bind(this);
  }

  render() {
    const { url } = this.props;
    const { isPlaying, progress } = this.state;

    let className = "media audio";
    if (isPlaying) {
      className += " playing";
    }

    // https://css-tricks.com/building-progress-ring-quickly/
    const containerSize = 100;
    const center = containerSize / 2;
    const strokeWidth = 3;
    const radius = containerSize / 2 - strokeWidth * 2;
    const circumference = 2 * Math.PI * radius;
    const offset = circumference - progress * circumference;

    return (
      <div className={className}>
        <audio src={url} ref={this.audioElemRef} />
        <button className={`play-button`} onClick={this.handleTogglePlay} disabled={!this.state.isDataLoaded}/>
        {/* <svg className="btn" width={containerSize} height={containerSize} 
          onClick={this.handleTogglePlay}
        >
          <circle
            className="progress_circle"
            strokeWidth={strokeWidth}
            fillOpacity="1"
            stroke="white"
            cx={center}
            cy={center}
            r={radius}
            strokeDasharray={`${circumference} ${circumference}`}
            strokeDashoffset={offset}
          />
        </svg> */}
      </div>
    )
  }
  
  handleLoadedData() {
    this.setState({
      isDataLoaded: true
    })
  }

  handleTogglePlay() {
    if (!this.audioElemRef.current) return;
    const elem = this.audioElemRef.current;
    if (this.state.isPlaying) {
      elem.pause();
    } else {
      elem.play();
    }
  }

  handlePlayEvent() {
    this.setState({ isPlaying: true });
  }

  handlePauseEvent() {
    this.setState({ isPlaying: false });
  }

  handleEndedEvent() {
    this.setState({ isPlaying: false });
  }

  handleTimeUpdateEvent() {
    const elem = this.audioElemRef.current;
    if (elem) {
      let progress: number;
      const elapsed = elem.currentTime;
      const total = elem.duration;
      if (isNaN(total)) {
        progress = 0; // not available
      } else if (total === Infinity) {
        progress = 1; // streaming
      } else {
        progress = elapsed / total;
      }

      this.setState({ progress });
    }
  }

  componentDidMount() {
    const audio = this.audioElemRef.current;
    if (audio) {
      audio.addEventListener('play', this.handlePlayEvent);
      audio.addEventListener('pause', this.handlePauseEvent);
      audio.addEventListener('ended', this.handleEndedEvent);
      audio.addEventListener('timeupdate', this.handleTimeUpdateEvent);
      audio.addEventListener('loadeddata', this.handleLoadedData);
    }
  }

  componentWillUnmount() {
    const audio = this.audioElemRef.current;
    if (audio) {
      audio.removeEventListener('timeupdate', this.handleTimeUpdateEvent);
      audio.removeEventListener('ended', this.handleEndedEvent);
      audio.removeEventListener('pause', this.handlePauseEvent);
      audio.removeEventListener('play', this.handlePlayEvent);
      audio.removeEventListener('loadeddata', this.handleLoadedData);
      
      if (this.state.isPlaying) {
        audio.pause();
      }
    }
  }
}